export enum AiExtractorSource {
    JSON_DATA = "JSON_DATA",
    ATTRIBUTES = "ATTRIBUTES"
}

export function formatAiExtractorSource(source: AiExtractorSource) {
    switch (source) {
        case AiExtractorSource.JSON_DATA:
            return "JSON data";
        case AiExtractorSource.ATTRIBUTES:
            return "attributes";
        default:
            return source;
    }
}

